module.exports = __webpack_public_path__ + "static/default-f27b6ad2a55a9e2754623ea13bd48f4c.png";